import(/* webpackMode: "eager", webpackExports: ["LoginSection"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/app/[locale]/myvivaldis/(auth)/register/components/blocks/LoginSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/app/[locale]/myvivaldis/(auth)/register/components/forms/RegisterForm.tsx");
;
import(/* webpackMode: "eager" */ "/builds/vivaldis/vivaldis_interim/frontend/src/assets/images/social_share.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/components/blocks/TranslatedPaths.tsx");
